import { lazy } from "react";

export { RESET_PASSWORD_PATH } from "./reset-password-path";
export const ResetPasswordPage = lazy(() => import("./reset-password"));
